import React, { useEffect, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import euroImg from "../../images/euro-icon-removebg-preview.png";
import gbpImg from "../../images/gbp-icon-removebg-preview.png";
import usdImg from "../../images/usd-icon-removebg-preview.png";
import { CurrencyContext } from "../services/currency/currency.context";

const Navigation = () => {
  const { setCurrency, currency, setRiskType, riskType } =
    useContext(CurrencyContext);
  const navigate = useNavigate();

  return (
    <div className="row">
      <div className="col-md-10 mx-auto mb-4"></div>
    </div>
  );
};

export default Navigation;
